import script from "./EducationPlanningHome.vue?vue&type=script&setup=true&lang=js"
export * from "./EducationPlanningHome.vue?vue&type=script&setup=true&lang=js"

import "./EducationPlanningHome.vue?vue&type=style&index=0&id=62222d7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62222d7e"]])

export default __exports__